module.exports = __webpack_public_path__ + "img/39.3.TP.1e3685d2.png";